module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rewards/purebarre-a3c3dd04af265e24ac26f8e1c6994022.svg";